import { render, staticRenderFns } from "./TabelaPapeis.vue?vue&type=template&id=d8a8b700&scoped=true"
import script from "./TabelaPapeis.vue?vue&type=script&lang=js"
export * from "./TabelaPapeis.vue?vue&type=script&lang=js"
import style0 from "./TabelaPapeis.vue?vue&type=style&index=0&id=d8a8b700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a8b700",
  null
  
)

export default component.exports